import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { areUserRolesIn } from '../helpers';
import { Roles, SupervisionNoteStatus } from '../constants';

import type { RootState } from '../store';

function useParentSupervisionEditable() {
  const { user } = useSelector((state: any) => state.auth);
  const { current: parentSupervision } = useSelector((state: RootState) => state.parentSupervision);
  const [isEditable, setIsEditable] = useState<boolean>(false);

  useEffect(() => {
    if (!user) return;
    if (
      !areUserRolesIn(user?.roles, [Roles.Bcba]) ||
      !parentSupervision ||
      !parentSupervision.id ||
      parentSupervision.status === SupervisionNoteStatus.Completed
    ) {
      setIsEditable(false);
    } else {
      setIsEditable(true);
    }
  }, [user, parentSupervision]);

  return isEditable;
}

export default useParentSupervisionEditable;
